import PropTypes from 'prop-types'
import { onValue, ref, set } from "firebase/database";
import { databaseChat, channel } from '../../firebase-config';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { MessageChat } from './MessageChat';
import { EmojiPicker } from './EmojiPicker';
import moment from 'moment';
import { NoAuthAlertComponent } from '../card/NoAuthAlertComponent';

export const ChatComponent = (props) => {

    const user = useSelector((state: any) => (state.auth));
    const [messages, setMessages] = useState([]);
    const [currentmessage, setCurrentmessage] = useState('');
    const refurl = channel + (user?.email ? user.email.replace('@', '-').replace('.', '-') : '');
    const chatRef = useRef(null);
    const [animate, setAnimate] = useState('inactive');

    useEffect(() => {
        const starCountRef = ref(databaseChat, refurl + '/messages');
        const unsub = onValue(starCountRef, (snapshot) => {
            const data: any[] = snapshot.val();
            if (data) {
                setMessages([...data]);
                chatRef.current.scrollTop = chatRef.current.scrollHeight;
            } else {
                setMessages([]);
            }
        });

        const timer = setTimeout(() => {
            setAnimate(props.show);
        }, 20);

        return () => {
            unsub();
            clearTimeout(timer);
        }
    }, [refurl, props]);


    const writeMessage = () => {

        console.log(messages);

        if (currentmessage === '') {
            return;
        }

        sendMessage(currentmessage);
    }

    const sendMessage = (msg) => {

        const msgdata = {
            "content": msg,
            "date": moment().format('D MMM, YYYY h:mm:ss A'),
            "id": refurl,
            "is_read": false,
            "sender_email": (user?.email ? user.email.replace('@', '-').replace('.', '-') : 'anonimo'),
            "name": user.name,
            "type": "text"
        }

        set(ref(databaseChat, refurl + '/messages/' + (messages.length)), msgdata).then(() => {
            setCurrentmessage('');
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
            //  chatRef.current.scrollToBottom();
        });

    }

    const setEmoji = (e) => {
        setCurrentmessage(currentmessage + e);
    }

    return (
        <div className={'fixed w-full bottom-0 h-auto bg-white z-50 shadow-inner transition-all ease-in-out delay-300 right-0 max-w-screen-sm ' + animate}
            style={{ 'borderRadius': '30px 30px 0px 0px', backgroundColor: '#F5F5F5' }}>

            <div className='flex justify-between p-4 border shadow-inner message_element_container bg-white' style={{ 'borderRadius': '30px 30px 30px 30px' }}>
                <div className='flex items-center'>
                    <img className='w-12 h-12 rounded-full' src="assets/img/user1.png" alt="Userfoto" />
                    <div className='ml-2'>
                        <span className='name-chat-text'>Sergio corral</span> <br />
                        <span className='rol-chat-text'>Concierge</span>
                    </div>
                </div>
                <div className='p-1 hover:bg-emerald-300 hover:text-white rounded-full w-10 h-10 flex justify-center items-center cursor-pointer' onClick={props.close}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8534 15.1463L8.70685 7.99973L15.8534 0.853187C16.0406 0.659461 16.0406 0.352271 15.8534 0.158485C15.6616 -0.0401235 15.345 -0.0456167 15.1464 0.146217L7.99988 7.29276L0.853394 0.146278C0.659668 -0.040856 0.352478 -0.040856 0.158691 0.146278C-0.0399171 0.338111 -0.0454101 0.65464 0.146423 0.853248L7.29291 7.99973L0.146423 15.1462C0.0526734 15.24 1.25035e-08 15.3671 1.25035e-08 15.4997C-6.10875e-05 15.7758 0.223816 15.9997 0.499939 15.9997C0.632568 15.9999 0.759766 15.9471 0.853394 15.8532L7.99988 8.7067L15.1464 15.8532C15.2401 15.9472 15.3673 15.9999 15.4999 15.9997C15.6324 15.9997 15.7595 15.9471 15.8533 15.8534C16.0486 15.6581 16.0486 15.3415 15.8534 15.1463Z" fill="#012349" />
                    </svg>

                </div>
            </div>

            <div ref={chatRef} className="max-w-4xl mx-auto space-y-3 grid grid-cols-1 h-96 overflow-y-scroll p-4 text-sm" >
                {
                    messages.map((message, index) => {
                        return (
                            <MessageChat key={index} {...message} user={user} />
                        )
                    })
                }
            </div>

            {
                user ?
                    (<div className='shadow-inner flex justify-between items-center message_element_container p-4 pr-4 bg-white'>

                        <EmojiPicker onSelect={setEmoji} />

                        <textarea className="bg-gray-200 w-4/6 appearance-none border-2 border-gray-200 rounded-lg py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-emerald-300" id="inline-full-name"
                            placeholder='Escribe un mensaje' rows={1}
                            value={currentmessage}
                            onChange={(e) => {
                                setCurrentmessage(e.target.value);
                            }}
                            onKeyDown={(e: any) => {
                                if (e.keyCode === 13) {
                                    writeMessage();
                                }
                            }}
                        ></textarea>

                        <div className='rounded-full bg-black w-12 h-12 flex justify-center items-center primary_btn' onClick={writeMessage}>
                            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.8877 3.38965L20.5049 10.0125L13.8877 16.6297" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
                                <path d="M20 10H1V0" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
                            </svg>

                        </div>
                    </div>) : (
                        <NoAuthAlertComponent />
                    )
            }


        </div>
    )
}

ChatComponent.propTypes = {
    show: PropTypes.string,
    close: PropTypes.func
}
